<!-- vue 3 项目内也有个同名文件 老的这边用老的 因为有 $store 相关数据要处理-->

<template>
  <van-loading style="margin-top: 15vh;" size="50px" type="spinner" vertical>登录成功, 正在跳转 ...</van-loading>
</template>

<script>
import { mall_wx_get_user_info, auth_wechat_token_login_by_code, wx_user_get_config_value } from "@/api/login"
import { Toast } from "vant"
import { go_redirect_url } from '@/util/util'

export default {
  mounted() {
    var token = this.$route.query.token;
    if (token) {
      Toast("请稍后, 正在跳转 ..")
      this.handle_token(token);
      return;
    }

    var code = this.$route.query.code;
    if (code) {
      this.handle_code(code);
      return;
    }

    budo_log.info("#27 query=", this.$route.query, "location=", location)
    Toast("错误, 请重新进入")
  },

  methods: {
    handle_code(code) {
      auth_wechat_token_login_by_code(code).then(data => {
        budo_log.debug("#34 auth_wechat_token_login_by_code", JSON.stringify(data))
        this.handle_token(data.access_token);
      });
    },

    handle_token(token) {
      budo_log.debug("#40 handle_token, login success, store SET_ACCESS_TOKEN, token=", token)

      sessionStorage.setItem("budo.v4_token_mall", token);
      this.$store.commit("SET_ACCESS_TOKEN", token);

      // 登录成功后写一下本地的一些数据
      mall_wx_get_user_info().then(res_user_info => {
        budo_log.debug("#90 handle_token, res_user_info=", JSON.stringify(res_user_info))

        const data = res_user_info.data || {};
        this.$store.commit("SET_USER_INFO", data);

        if (data.cityCode) {
          budo_log.debug("#57 handle_token, SET_CITY_NAME", data)

          this.$store.commit("SET_CITY_CODE", data.cityCode);
          this.$store.commit("SET_CITY_NAME", data.cityName);
        } else {
          budo_log.debug("#62 handle_token, SET_CITY_NAME", data)

          this.$store.commit("SET_CITY_CODE", "5101");
          this.$store.commit("SET_CITY_NAME", "成都市");
        }

        var r_url = localStorage.getItem("budo.v2_redirect_url")
        if((!r_url || '/v6/home' == r_url) && data.indexUrl) {
          localStorage.setItem("budo.v2_redirect_url", data.indexUrl)
        }

        // 无有效回跳地址（默认回首页）时，查字典取当前客户的默认入口地址（value 即目标，如 /uni/）；admin 登录不处理
        var is_default_redirect = (!r_url || '/v6/home' == r_url) && "login-admin" != (this.$route.query.from || "")
        if (is_default_redirect) {
          wx_user_get_config_value("h5.entry_default").then(value => {
            budo_log.info("#73 entry_default value=", value)
            if (value) {
              localStorage.setItem("budo.v2_redirect_url", value)
            }
            go_redirect_url()
          }).catch(() => {
            go_redirect_url()
          })
          return
        }

        // 用户未绑定手机号 用户未绑卡 不统一处理 某些页面不需处理 这个代码已搬到 App.vue

        // 回到业务页面
        go_redirect_url();
      })
    }
  }
}
</script>